export const PENGEMBANGAN_KOMPETENSI_HINTS: Array<string> = [
  'Hasil Refleksi Kompetensi Anda (jika ada)',
  'Hasil diskusi bersama Tim Kinerja tentang fokus dan kemampuan selama 6 bulan ke depan',
]

export const MIN_ACTIVITY_POINTS = 24
export const MAX_ACTIVITY_POINTS = 32

export const INDICATOR_GROUP_BADGES = {
  needImprovement: {
    title: 'Indikator yang perlu ditingkatkan',
    variant: 'warning',
  },
  strong: {
    title: 'Indikator terkuat',
    variant: 'success',
  },
}

export const INDICATOR_REFERENSI_KOMPETENSI_KEYS = ['needImprovement', 'strong']

export const PENGEMBANGAN_KOMPETENSI_ACTIVITY_LOCATION = {
  DI_DALAM_LINGKUNGAN_DINAS_PENDIDIKAN: 'Dilakukan secara mandiri',
  DI_LUAR_LINGKUNGAN_DINAS_PENDIDIKAN:
    'Dilakukan di dalam komunitas atau organisasi profesi di dalam lingkungan Dinas Pendidikan',
}
